/** Message d'erreur de lecture, à afficher à la place d'une liste quand la requête a échoué. */
export function QueryError({ error }: { error: unknown }) {
  const message = (error as { message?: string })?.message ?? "Erreur inconnue";
  return (
    <div role="alert" className="rounded-2xl border border-destructive/30 bg-destructive/10 px-4 py-3 text-sm">
      <span className="font-semibold text-destructive">Impossible de charger les données.</span> {message} — l'erreur est dans la Console.
    </div>
  );
}
